import { getCorrelationId } from '@paybis/frontend-common-lib/src/services/correlation';
import eventBus from '../../helpers/eventBus';

export function handleResponseError(error) {
  eventBus.emit('error', error);

  return Promise.reject(error);
}

export function addCorrelationId(config) {
  config.headers['X-Correlation-ID'] = getCorrelationId();
  return config;
}
